import React, { useState, useEffect, Component } from 'react';
import { Link } from 'react-router-dom';
import deleteicon from "../../images/icon/delete.png";
import editicon from "../../images/icon/edit.png";
import pendingicon from "../../images/icon/pending.png";
import cenableicon from "../../images/icon/cenable.png";
import cdisableicon from "../../images/icon/cdisable.png";
import admin from "../../images/banner/admin.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';

function Pendingconsultants(){
    const [records, setRecords] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    
    useEffect(() => {
        axios.get("https://api.transnational.ai/api/pendingconsultants") 
            .then(response => {
                console.log(response.data)
                setRecords(response.data.pconsultants);
            })
            .catch(error => {
                console.error('Error fetching records:', error);
            });
    }, []); 

    const handleFilterchange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredRecords = records.filter((record) =>
        record.fname.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleDelete = async (id) => {
        try {
          axios.get(`https://api.transnational.ai/api/deleteconsultant/${id}`);
          setRecords(records.filter(record => record.id !== id));
        } catch (error) {
          console.error('Error deleting record:', error);
        }
    };

    const handleStatus = (id) => {
        axios.get(`https://api.transnational.ai/api/pconsultantstatus/${id}`);
        setRecords(records.map(record => record.id === id ? { ...record, status: record.status === 'Y' ? 'N' : 'Y' } : record));     
    }

    const servicesStyle = {
        backgroundImage: `url(${admin})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundColor :'#e6f4ff',
        width :'100%',
        height: '33vh',
    };

    const getCstatusImage = (cstatus) => {
        switch (cstatus) {
            case 'Y':
                return <img src={cenableicon} alt="Active"  width={18} height={18} />;
            case 'N':
                return <img src={cdisableicon} alt="Inactive" width={18} height={18} />;
            default:
                return <img src={pendingicon} alt="Inactive" width={18} height={18} />;
        }
    };

    return (
        <section style={{ background :'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="container" style={{ background :'#ffffff' }}>
                <div className="col-12" style={{ margin:'0 auto'}}>
                    <div className="well well-small" style={{ textAlign:"left" }}>
                        <ul className="media-list">
                            <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                    <div  className="col-md-12 breadcrumbs" >
                                    <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Consultantdashboard">Consultant Dashboard</a> <i class="bi bi-chevron-double-right"></i> <span>Pending Consultants</span>
                                    </div>
                                </section>
                                <div className="container">
                                    <div className='row'>
                                        <div className="col-9" style={{ marginLeft:'25px'}}>
                                                                                                                      
                                        </div>
                                        <div className="col-3" style={{ marginLeft:'-40px'}}>
                                            <input style={{ height:"35px",marginRight:"-5px",width:"255px"}} value={searchTerm} onChange={handleFilterchange} type='text' name='keyword' maxLength={150} placeholder='search consultant' />
                                            <button class="btn btn-warning" style={{ marginTop:"-5px",backgroundColor:"#ccc",border:"#ccc"}} type="button"><i class="bi bi-search" style={{ fontSize:"10px"}}></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div className="media-body" style={{ minHeight : '500px' , padding : '40px',marginTop:"-20px"}}>
                                    <h3 className="media-heading"></h3>
                                    
                                    <table className="mytable">
                                    <thead>
                                        <tr>
                                        <th>Consultant Name</th>
                                        <th>Job Title</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Work Authorization</th>
                                        <th>State</th>
                                        <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {filteredRecords.map(item => (
                                        <tr  key={item.id}>
                                        <td>{item.fname} {item.lname}</td>
                                        <td>{item.jobtitle}</td>
                                        <td>{item.email}</td>
                                        <td>{item.tel}</td>
                                        <td>{item.workauthorization}</td>
                                        <td>{item.state}</td>
                                        <td><button onClick={() => handleStatus(item.id)}>{getCstatusImage(item.cstatus)}</button><button onClick={() => handleDelete(item.id)} style={{ marginLeft:'10px'}}><img src={deleteicon} width={18} height={18} /></button></td>
                                        </tr>
                                    ))} 
                                    </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );

}
export default Pendingconsultants